<template>
  <notification
    class="sb-notification--counter"
    :visible="notificationRecent || (notificationSimilar && similarEnabled)"
  >
    <!-- {{ 1 }} -->
  </notification>
</template>
<script>
import notification from "./Notification.vue";
import { mapState } from "vuex";
export default {
  components: {
    notification,
  },
  computed: {
    ...mapState([
      "notificationSimilar",
      "notificationRecent",
      "similarEnabled",
    ]),
  },
};
</script>
<style scoped>
.sb-notification--counter {
  width: 18px !important;
  height: 18px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px !important;
  border-width: 2px !important;
  color: #fff;
  animation: none !important;
}
.shopbox-right .sb-notification--counter {
  right: unset;
  left: -5px;
}
</style>
